<template lang="pug">
li.content
    .icon.file(
        v-if="filetype === 'file'"
        :style="{ 'min-width': `${width}px`, height: `${height}px` }"
    )
        font-awesome-icon(icon="file-alt")

    //- a.thumbnail(
    //-     v-else-if="filetype === 'image' && thumbnail"
    //-     href="#" @click.stop.prevent="$emit('crop', media)"
    //-     :style="{ 'min-width': `${width}px`, height: `${height}px` }"
    //- )
        img(:src="thumbnail" :style="{ 'min-width': `${width}px`, height: `${height}px` }")

    .icon(
        v-else
        :class="filetype"
        :style="{ 'min-width': `${width}px`, height: `${height}px` }"
    )
        font-awesome-icon(:icon="`file-${filetype}`")

    .filename(v-line-clamp:24="1") {{ filename }}
    .filesize {{ filesize | prettyBytes }}
    .actions
        a(:href="`${src}?download`") herunterladen
</template>

<script>
import _ from 'lodash'
import mime from 'mime'

export default {
    name: 'MediaPreview',
    props: {
        media: {
            type: Object,
            required: true
        },
        width: {
            type: Number,
            required: true
        },
        height: {
            type: Number,
            required: true
        },
    },
    computed: {
        type() {
            return this.media.type
        },
        file() {
            switch (this.type) {
                case 'file':
                    return _.get(this.media, 'file')
                case 'image':
                case 'video':
                    return _.get(this.media, `${this.type}.source`)
            }
        },
        filename() {
            return _.get(this.file, 'name')
        },
        filesize() {
            return parseInt(_.get(this.file, 'size'))
        },
        filetype() {
            let filetype

            const m = _.get(this.file, 'mime')
            const suffix = mime.getExtension(m)
            switch (suffix) {
                case 'jpg':
                case 'jpeg':
                case 'png':
                    filetype = 'image'
                    break;

                case 'mp4':
                case 'mpeg':
                case 'webm':
                case 'qt':
                    filetype = 'video'
                    break;

                case 'zip':
                case 'rar':
                case 'gzip':
                case 'tar':
                case 'tar.gz':
                case 'tar.gzip':
                    filetype = 'archive'
                    break;

                case 'doc':
                case 'docx':
                case 'docm':
                case 'docb':
                case 'dotx':
                case 'dotm':
                    filetype = 'word'
                    break;

                case 'ppt':
                case 'pptx':
                case 'pptm':
                    filetype = 'powerpoint'
                    break;

                case 'xls':
                case 'xlsx':
                    filetype = 'excel'
                    break;

                case 'csv':
                    filetype = 'csv'
                    break;

                case 'mp3':
                case 'wav':
                    filetype = 'audio'
                    break;

                default:
                    filetype = 'file'
            }

            return filetype
        },
        src() {
            const storageRoute = _.trim(`${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`, '/')

            let table = 'files'

            let id = this.file.id
            const name = this.file.name

            switch (this.type) {
                case 'image':
                    table = 'images'
                    id = _.get(this.media, `${this.type}.id`)
                    break;

                case 'video':
                    table = 'videos'
                    id = _.get(this.media, `${this.type}.id`)
                    break;
            }

            return `${storageRoute}/${table}/${id}/${name}`
        },
        thumbnail() {
            if (this.type === 'image') {
                const fit = `fit=crop&crop=focalpoint&x=.5&y=.5&z=1&w=${this.width}&h=${this.height}`
                // const fit = `fit&h=${this.height}`
                return `${this.src}&${fit}`
            }
        },
    }
}
</script>

<style lang="sass" scoped>

@import '~@/assets/sass/variables';

$skeletonColor: #D8D8D8;

li.content
    background: rgba(220,220,220,.3)
    margin-bottom: .5rem
    border-radius: 4px
    display: grid
    grid-template-rows: 24px 18px 22px
    grid-template-columns: max-content auto
    // column-gap: .5rem
    padding-right: .5rem

    &.deleted
        .thumbnail, .filename, .filesize, .actions, .icon
            opacity: .6
            filter: grayscale(1) blur(1px)
            user-select: none
            pointer-events: none

    .thumbnail
        position: relative
        img
            background: $skeletonColor
            border-top-left-radius: 4px
            border-bottom-left-radius: 4px
            display: block

    .icon
        font-size: 3rem
        display: flex
        justify-content: center
        align-items: center
        color: darken($skeletonColor, 20%)

    .filename, .filesize, .actions
        line-height: 1.3
        grid-column: 2

    .filename
        padding-right: 30px
        font-size: 1.2rem
        line-height: 24px
        padding-top: 2px

    .filesize
        font-size: .8rem

    .actions
        a
            text-decoration: none
            &:hover
                text-decoration: underline


</style>
